var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"lay"},_vm._l((_vm.datas),function(item){return _c('div',{key:item.id,staticClass:"row",on:{"click":function($event){return _vm.handleRow(item)}}},[_c('div',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }